module.exports = __webpack_public_path__ + "img/04.27ecb05a.png";